import { useMediaQueryBreakpoint } from "@hooks";

import {
  QuestionContainer,
  QuestionCountContainer,
  QuestionsList,
  AnswerText,
} from "./styles.styled";

interface QuestionItem {
  question: string;
  answer?: string;
}

export interface ContactQuestionsContent {
  questions: Array<QuestionItem | string>;
}

interface ContactQuestionsProps extends ContactQuestionsContent {
  className?: string;
}

export const ContactQuestions = ({
  questions,
  className,
}: ContactQuestionsProps) => {
  const { isDesktop } = useMediaQueryBreakpoint();

  return (
    <QuestionsList className={className ?? "mt-4"}>
      {questions.map((item, index) => {
        const question = typeof item === "string" ? item : item.question;
        const answer = typeof item === "string" ? undefined : item.answer;

        return (
          <li
            key={index}
            className="flex items-start gap-2 max-w-6xl w-full mx-auto"
          >
            {isDesktop && (
              <QuestionCountContainer>{index + 1}</QuestionCountContainer>
            )}

            <QuestionContainer>
              <div>{question}</div>
              {answer && <AnswerText>{answer}</AnswerText>}
            </QuestionContainer>
          </li>
        );
      })}
    </QuestionsList>
  );
};
